import { Application, ICanvas } from 'pixi.js'
import { ApplicationSize } from '../type/PixiType'
import { isMobile } from './deviceUtil'

/**
 * 外接螢幕 devicePixelRatio 常為 1，canvas 渲染密度不足會讓貼圖邊緣出現鋸齒。
 * 非 mobile 裝置將 resolution 下限拉到 2 做 supersampling 補償；mobile 維持原生 DPR。
 */
export function getAppResolution(): number {
  const dpr = window.devicePixelRatio || 1
  return isMobile() ? dpr : Math.max(dpr, 2)
}

export let appScreen: {
  width: number
  height: number
}

export function setAppScreen(width: number, height: number) {
  appScreen = {
    width,
    height,
  }
}
export let app: Application<ICanvas>
export let defaultSize: ApplicationSize

export function setApp(instance: Application<ICanvas>) {
  app = instance
}

/**
 * @deprecated: Should use <PixiApp> in new project
 */
let ratio: number

let initHeight: number
let initWidth: number

/**
 * @deprecated: Should use <PixiApp> in new project
 */
export function createPixiApp(defaultWidth: number, defaultHeight: number, storyMode = false, isForBothLayout = false) {
  initHeight = defaultHeight
  initWidth = defaultWidth

  defaultSize = calculateSize(isForBothLayout)

  app = new Application({
    width: storyMode ? defaultWidth : window.innerWidth,
    height: storyMode ? defaultHeight : window.innerHeight,
    antialias: true,
    autoDensity: true,
    backgroundColor: '#25272B',
    resolution: getAppResolution(),
    view: document.getElementById('view') as unknown as ICanvas,
  })

  window.__PIXI_APP__ = app
  return app
}

export function calculateSize(isForBothLayout = false): ApplicationSize {
  const windowWidth = window.innerWidth
  const windowHeight = window.innerHeight
  const isPortrait = windowWidth < windowHeight && isForBothLayout

  appScreen = {
    width: isPortrait ? initHeight : initWidth,
    height: isPortrait ? initWidth : initHeight,
  }

  ratio = appScreen.height / appScreen.width
  let width = windowWidth
  let height = width * ratio

  if (height > windowHeight) {
    height = windowHeight
    width = height / ratio
  }

  const scale = width / appScreen.width
  const x = (windowWidth - width) / 2
  const y = (windowHeight - height) / 2

  return {
    scale,
    x,
    y,
  }
}
